import { NotificationController } from 'core-components/library/popup'
import Logger from 'src/core/utils/Logger'

export const sendNotification = (message: string, messageToLog?: string) => {
  if (messageToLog) {
    Logger.error(messageToLog)
  }
  NotificationController.showError({ message })
}
